import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  CButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CRow,
  CCol,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CSpinner,
} from "@coreui/react";

import CIcon from "@coreui/icons-react";
import { cilTrash, cilPlus, cilPencil } from "@coreui/icons";

import "./ProtocolsTab.scss";
import "../../Table/Table.scss";

import ProtocolAdhesion from "../../Protocols/ProtocolAdhesion"; // Протокол Адгезии
import ProtocolVerticality from "../../Protocols/ProtocolVerticality"; // Протокол Вертикальности
import ProtocolSteelHardness from "../../Protocols/ProtocolSteelHardness"; // Протокол Твердости стали
import ProtocolTensions from "../../Protocols/ProtocolTensions"; // Протокол усилий натяжения
import ProcotolThickness from "../../Protocols/ProcotolThickness"; // Протокол толщины стенки
import ProtocolConcrete from "../../Protocols/ProtocolConcrete"; // Прочность бетона
import ProtocolEControl from "../../Protocols/ProtocolEControl"; // Высотные отметки
import ProtocolDynamic from "../../Protocols/ProtocolDynamic"; // Динамические параметры
import ProtocolGrounding from "../../Protocols/ProtocolGrounding"; // Сопротивление заземления
import ProtocolLkp from "../../Protocols/ProtocolLkp"; // Толщина ЛКП

const ProtocolsTab = ({ object, activeTab }) => {
  const [protocols, setProtocols] = useState([]);
  const [editTypeProtocol, setEditTypeProtocol] = useState({
    id: null,
    type: "",
  });
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showTypeModal, setShowTypeModal] = useState(false);
  const [showProtocolFormModal, setShowProtocolFormModal] = useState(false);
  const [selectedProtocolType, setSelectedProtocolType] = useState(null);
  const [selectedNValue, setSelectedNValue] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [selectedProtocolId, setSelectedProtocolId] = useState(null);
  const [activeProtocolId, setActiveProtocolId] = useState(null);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (object?.LDoc) {
      setLoading(true);
      setErrorMessage("");
      axios
        .get(`/api/ldoc/${object.LDoc}/protocols/`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const result = response.data;
          if (result.message) {
            setErrorMessage(result.message);
            setProtocols([]);
          } else {
            setProtocols(result.data || []);
          }
        })
        .catch((error) => {})
        .finally(() => setLoading(false));
    } else {
      setProtocols([]);
    }
  }, [object?.LDoc, activeTab, token]);

  const protocolTypes = [
    "Протокол контроля вертикальности ствола опоры методом угловых измерений",
    "Протокол измерений твердости стали основных элементов",
    "Протокол измерений усилий натяжения в канатах оттяжек мачты",
    "Протокол измерений толщины стенки замкнутых элементов",
    "Протокол определния прочтоности бетона фундамента",
    "Протокол измерений высотных отметок фундаментов",
    "Протокол измерения динамических параметров",
    "Протокол определния адгезии лакокрасочного покрытия элемента",
    "Протокол измерений сопротивления заземляющего устройства",
    "Протокол измерения толщины лакокрасочного покрытия",
  ];

  const protocolComponentMap = {
    "Протокол контроля вертикальности ствола опоры методом угловых измерений":
      ProtocolVerticality,
    "Протокол измерений твердости стали основных элементов":
      ProtocolSteelHardness,
    "Протокол измерений усилий натяжения в канатах оттяжек мачты":
      ProtocolTensions,
    "Протокол измерений толщины стенки замкнутых элементов": ProcotolThickness,
    "Протокол определния прочтоности бетона фундамента": ProtocolConcrete,
    "Протокол измерений высотных отметок фундаментов": ProtocolEControl,
    "Протокол измерения динамических параметров": ProtocolDynamic,
    "Протокол определния адгезии лакокрасочного покрытия элемента":
      ProtocolAdhesion,
    "Протокол измерений сопротивления заземляющего устройства":
      ProtocolGrounding,
    "Протокол измерения толщины лакокрасочного покрытия": ProtocolLkp,
  };

  const handleProtocolSelect = (type) => {
    const index = protocolTypes.indexOf(type);
    setSelectedProtocolType(type);
    setSelectedNValue(index);
    setShowTypeModal(false);
    setTimeout(() => setShowProtocolFormModal(true), 300);
  };

  const handleRowClick = (item) => {
    setSelectedProtocolId(item.Id);
    setActiveProtocolId(item.Id);
    setEditTypeProtocol({ id: item.Id, type: item.Name });
  };

  const editModalShow = () => {
    handleProtocolSelect(editTypeProtocol.type);
  };

  const fetchProtocols = () => {
    if (!object?.LDoc) return;
    setLoading(true);
    setErrorMessage("");
    axios
      .get(`/api/ldoc/${object.LDoc}/protocols/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const result = response.data;
        if (result.message) {
          setErrorMessage(result.message);
          setProtocols([]);
        } else {
          setProtocols(result.data || []);
        }
      })
      .catch((error) => {})
      .finally(() => setLoading(false));
  };

  const handleDeleteProtocol = () => {
    if (!selectedProtocolId) {
      alert("Не выбран протокол для удаления");
      return;
    }
    setShowDeleteConfirm(true);
  };

  const confirmDelete = () => {
    axios
      .delete("/api/protocol/save/", {
        data: { Id: selectedProtocolId },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        fetchProtocols();
        setSelectedProtocolId(null);
      })
      .catch((error) => {
        alert("Ошибка при удалении протокола");
      })
      .finally(() => {
        setShowDeleteConfirm(false);
      });
  };

  return (
    <div>
      {/* Кнопки управления */}
      <div className="mb-3 d-flex gap-2 flex-wrap">
        <button
          className="button protocols-tab__button"
          onClick={() => setShowTypeModal(true)}
        >
          <CIcon
            customClassName="protocols-tab__svg protocols-tab__svg--plus"
            icon={cilPlus}
          />
        </button>
        <button
          className="button protocols-tab__button"
          onClick={handleDeleteProtocol}
        >
          <CIcon
            customClassName="protocols-tab__svg protocols-tab__svg--delete"
            icon={cilTrash}
          />
        </button>
        <button
          className="button protocols-tab__button"
          onClick={() => editModalShow()}
        >
          <CIcon customClassName="protocols-tab__svg" icon={cilPencil} />
        </button>
        <button className="button protocols-tab__button">Отчеты</button>
        <button className="button protocols-tab__button  protocols-tab__button--green-сolor">
          Загрузить геодезию
        </button>
      </div>

      {/* Модальное окно выбора типа протокола */}
      <CModal
        visible={showTypeModal}
        onClose={() => setShowTypeModal(false)}
        alignment="top"
      >
        <div style={{ maxWidth: "1000px", width: "100%", margin: "auto" }}>
          <div
            style={{
              background: "white",
              borderRadius: "0.3rem",
              overflow: "hidden",
            }}
          >
            <CModalHeader>
              <CModalTitle>Укажите тип протокола</CModalTitle>
            </CModalHeader>
            <CModalBody>
              <CRow>
                {protocolTypes.map((type, index) => (
                  <CCol xs={6} key={index} className="mb-2">
                    <CButton
                      color="light"
                      className="w-100 text-wrap"
                      style={{
                        height: "5.5rem",
                        fontSize: "0.9rem",
                        lineHeight: "1.1rem",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        whiteSpace: "normal",
                      }}
                      onClick={() => {
                        setActiveProtocolId(null);
                        handleProtocolSelect(type);
                      }}
                    >
                      {type}
                    </CButton>
                  </CCol>
                ))}
              </CRow>
            </CModalBody>
          </div>
        </div>
      </CModal>

      {/* Модальное окно формы протокола */}
      <CModal
        visible={showProtocolFormModal}
        onClose={() => {
          setShowProtocolFormModal(false);
          setSelectedProtocolType(null);
          setSelectedNValue(null);
        }}
        alignment="top"
        size="xl"
        scrollable
      >
        <CModalHeader>
          <CModalTitle>{selectedProtocolType}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {selectedProtocolType &&
            React.createElement(protocolComponentMap[selectedProtocolType], {
              ldoc: object.LDoc,
              nvalue: selectedNValue,
              activeProtocolId: activeProtocolId,
              refreshProtocols: fetchProtocols,
              onSaveProtocol: (protocol) => {
                setSelectedProtocolId(protocol.Id);
                setShowProtocolFormModal(false);
              },
            })}
        </CModalBody>
      </CModal>

      {/* Таблица существующих протоколов */}
      {loading ? (
        <CSpinner color="primary" />
      ) : errorMessage ? (
        <p>{errorMessage}</p>
      ) : protocols.length > 0 ? (
        <CTable className="about-objects__table">
          <CTableHead className="about-objects__head">
            <CTableRow>
              <CTableHeaderCell>Наименование</CTableHeaderCell>
              <CTableHeaderCell>№ протокола</CTableHeaderCell>
              <CTableHeaderCell>Дата</CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          <CTableBody className="about-objects__body">
            {protocols.map((item, index) => (
              <CTableRow
                key={index}
                className={selectedProtocolId === item.Id ? "active-row" : ""}
                onClick={() => handleRowClick(item)}
              >
                <CTableDataCell>{item.Name || "N/A"}</CTableDataCell>
                <CTableDataCell>{item.ProtocolNum || "N/A"}</CTableDataCell>
                <CTableDataCell>{item.ProtocolDate || "N/A"}</CTableDataCell>
              </CTableRow>
            ))}
          </CTableBody>
        </CTable>
      ) : (
        <p>Протоколы не найдены.</p>
      )}

      {/* Модальное окно подтверждения удаления */}
      <CModal
        visible={showDeleteConfirm}
        onClose={() => setShowDeleteConfirm(false)}
      >
        <CModalHeader>
          <CModalTitle>Подтверждение удаления</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <p>Вы уверены, что хотите удалить этот протокол?</p>
          <div className="d-flex justify-content-end gap-2">
            <CButton
              color="secondary"
              onClick={() => setShowDeleteConfirm(false)}
            >
              Нет
            </CButton>
            <CButton color="danger" onClick={confirmDelete}>
              Да
            </CButton>
          </div>
        </CModalBody>
      </CModal>
    </div>
  );
};

export default ProtocolsTab;
